import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { isPhone, checkEmail, isCardNo } from '@/utils/validate';
import { mapState } from 'vuex';
import tableDetailModal from './components/tableDetailModal.vue';
import xlsx from 'xlsx';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { insuranceResource, mainPlanResource } from '@/views/insurance/insuranceManage/request';
import { planRelateData } from '@/views/policy/customerManage/request';
import { balckListResource } from './request';
export default {
  props: ['visible'],
  components: {
    tableDetailModal
  },
  data() {
    const h = this.$createElement;
    return {
      indicator: h("a-icon", {
        "attrs": {
          "type": "loading",
          "spin": true
        },
        "style": "font-size: 24px"
      }),
      form: {
        insuranceId: undefined,
        insuranceName: undefined
      },
      fileList: [],
      data: [],
      column: [],
      allData: [],
      // 投保信息分组object【】
      classify: {},
      // 数据分组
      detailVisible: false,
      insuranceList: [],
      planList: [],
      infoKeys: [{
        name: '产品信息',
        code: 'product'
      }, {
        name: '保险信息',
        code: 'commonInfo'
      }, {
        name: '投保人信息',
        code: 'applicant'
      }, {
        name: '被保险人信息',
        code: 'insured'
      }],
      templateRenderList: [],
      isPERSON: true,
      finished: true,
      currentFileInfo: {},
      discountInfoList: [],
      personBlackList: [],
      companyBlackList: []
    };
  },
  watch: {
    visible(newV) {
      if (newV) {
        this.getProduction();
      }
    }
  },
  computed: {
    rules() {
      return {
        insuranceId: [{
          required: true,
          message: this.$t('请选择') + this.$t('产品名称'),
          trigger: 'change'
        }]
      };
    },
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  methods: {
    async getProduction() {
      this.insuranceList = await insuranceResource({
        position: 'batchPolicy'
      });
      this.insuranceList = this.insuranceList.filter(item => item.id == this.$route.params.id);
    },
    async getBlackResource() {
      balckListResource({}).then(res => {
        console.log(res, 'balckListResource');
        res && Array.isArray(res) && res.forEach(item => {
          if (item.blacklistType === 'company') {
            this.companyBlackList.push(item.companyName);
          } else if (item.blacklistType === 'person') {
            this.personBlackList.push(item.idNo);
          }
        });
      });
    },
    async onDownLoad() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          var _Object$keys;
          let obj = this.insuranceList.find(i => i.insuranceCustomerId == this.form.insuranceId);
          if ((_Object$keys = Object.keys(obj)) !== null && _Object$keys !== void 0 && _Object$keys.length) {
            if (obj.batchTemplate) {
              let url = process.env.VUE_APP_File + obj.batchTemplate;
              // 解决跨域download属性不生效问题
              let x = new XMLHttpRequest();
              x.open('GET', url, true);
              x.responseType = 'blob';
              x.onload = function (e) {
                let _url = window.URL.createObjectURL(x.response);
                let a = document.createElement('a');
                a.href = _url;
                a.download = obj.batchTemplateName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              };
              x.send();
            } else {
              this.$message.destroy();
              this.$message.error(this.$t('该产品暂无批量投保模板'));
            }
          }
        }
      });
    },
    onValid() {
      this.$refs.formRef.validate(() => {
        this.$message.destroy();
        this.$message.error(this.$t('该产品暂无批量投保模板'));
      });
    },
    beforeUpload(file) {},
    handleChange(info) {
      if (!info.file) {
        return;
      }
      const imgReg = /(xlsx|xls)$/;
      const filename = info.file.name;
      const imgSuffix = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
      const isExcel = imgReg.test(imgSuffix);
      if (!isExcel) {
        this.$message.destroy();
        this.$message.error(this.$t('暂不支持此文件类型，请重新上传'));
        return;
      }
      if (info.file.size > 2 * 1024 * 1024) {
        this.$message.destroy();
        this.$message.error(this.$t('文件大小超过1M'));
        return;
      }
      this.currentFileInfo = info;
      this.fileList = this.currentFileInfo.fileList;
    },
    // 将处理xlsx合并单元格数据，方便转换成json
    initMerge(sheet) {
      let A = 65;
      let mergeMap = {};
      const merges = sheet['!merges'];
      merges.forEach(p => {
        let columnIndex = p['s']['c'];
        const endColumn = p['e']['c'];
        let rowIndex = p['s']['r'];
        const endRow = p['e']['r'];
        const startColumn = String.fromCharCode(A + p['s']['c']);
        const startRow = p['s']['r'] + 1;
        while (columnIndex <= endColumn) {
          rowIndex = p['s']['r'];
          while (rowIndex <= endRow) {
            let column = String.fromCharCode(A + columnIndex);
            let row = rowIndex + 1;
            // let a = sheet[startColumn + startRow]['v'];
            mergeMap[column + row] = sheet[startColumn + startRow];
            // mergeMap[column + row] = sheet[startColumn + startRow]['v'];
            rowIndex++;
          }
          columnIndex++;
        }
      });
      Object.assign(mergeMap, sheet);
      return mergeMap;
    },
    // 分别处理Sheet1/2的数据
    async processingSheetData(sheet, mergeMap, sheetIndex) {
      var _this$templateRenderL;
      this.personBlackList = [];
      this.companyBlackList = [];
      await this.getBlackResource();
      this.templateRenderList = [];
      let ref;
      let ref1;
      let insureRef1;
      let insureRef2;
      if (sheetIndex === 0) {
        ref = sheet['!ref'].replace('A1', 'A5');
        ref1 = sheet['!ref'].replace('A1', 'A6');
        insureRef1 = sheet['!ref'];
        insureRef2 = sheet['!ref'].replace('A1', 'A5');
      } else {
        ref = sheet['!ref'].replace('A1', 'A2');
        ref1 = sheet['!ref'].replace('A1', 'A3');
        insureRef2 = sheet['!ref'].replace('A1', 'A2');
      }
      let firstColumn = xlsx.utils.sheet_to_json(recursionCopy(mergeMap), {
        range: ref,
        defval: ''
      })[0];
      // 第一张表企业投保数据
      let insureData = xlsx.utils.sheet_to_json(recursionCopy(mergeMap), {
        range: insureRef1,
        defval: ''
      }).slice(0, 3);
      insureData = insureData.map((item, i) => {
        return Object.values(item);
      });
      let applicant = [];
      insureData[1].map((item, i) => {
        if (item) {
          let obj = {
            name: item,
            inputValue: insureData[2][i]
          };
          applicant.push(obj);
        }
      });
      let _column = [];
      let insured3 = 0;
      Object.entries(firstColumn).map(item => {
        var _item$1$toString, _item$1$toString2;
        if ((_item$1$toString = item[1].toString()) !== null && _item$1$toString !== void 0 && _item$1$toString.includes('产品名称') || (_item$1$toString2 = item[1].toString()) !== null && _item$1$toString2 !== void 0 && _item$1$toString2.includes('方案名称')) {
          _column.push({
            slots: {
              title: item[1]
            },
            dataIndex: item[1],
            key: item[1],
            align: 'center',
            className: 'td-bg'
          });
        } else {
          var _item$0$toString, _item$1$toString3;
          if ((_item$0$toString = item[0].toString()) !== null && _item$0$toString !== void 0 && _item$0$toString.includes('被保险人信息') && !((_item$1$toString3 = item[1].toString()) !== null && _item$1$toString3 !== void 0 && _item$1$toString3.includes('与投保人关系')) && insured3 < 3) {
            _column.push({
              slots: {
                title: item[1]
              },
              dataIndex: item[1],
              key: item[1],
              align: 'center',
              className: 'td-bg'
            });
            insured3 += 1;
          }
        }
      });
      // _column.push({
      //   slots: {title: '操作'},
      //   dataIndex: 'action',
      //   key: 'action',
      //   scopedSlots: {customRender: 'action'},
      //   align: 'center',
      //   width: 180,
      //   className: 'td-bg'
      // });
      this.column = _column;
      this.data = xlsx.utils.sheet_to_json(recursionCopy(mergeMap), {
        range: ref1,
        defval: ''
      }).map((item, index, data) => {
        if (!item['*产品名称']) {
          Object.assign(item, {
            '*产品名称': data[0]['*产品名称']
          });
        }
        item.id = index;
        item.errorMessage = [];
        return item;
      });
      if (sheetIndex) {
        this.isPERSON = true;
      } else {
        this.isPERSON = false;
      }
      // 匹配模板数据值
      let valueData = xlsx.utils.sheet_to_json(recursionCopy(mergeMap), {
        range: insureRef2,
        defval: ''
      });
      if (sheetIndex === 0) {
        valueData = valueData.map((item, index) => {
          applicant.forEach((app, appIndex) => {
            item['投保人信息' + (appIndex === 0 ? '' : '_' + appIndex)] = index === 0 ? app.name : app.inputValue;
            firstColumn['投保人信息' + (appIndex === 0 ? '' : '_' + appIndex)] = app.name;
          });
          return item;
        });
      }
      // 处理模板数据
      this.templateRenderList = await this.processingData(this.codeGroup(firstColumn, valueData));
      this.finished = true;
      if (((_this$templateRenderL = this.templateRenderList) === null || _this$templateRenderL === void 0 || (_this$templateRenderL = _this$templateRenderL.insuredInfo) === null || _this$templateRenderL === void 0 ? void 0 : _this$templateRenderL.length) > 10000) {
        this.$message.error('导入数据超过10000条，同步数据失败！');
        return;
      }
      this.detailVisible = true;
    },
    // 处理字段为模板格式
    codeGroup(data, valueData) {
      let _d = {};
      Object.entries(data).map(item => {
        let res = this.infoKeys.find(i => item[0].includes(i.name));
        if (res) {
          if (Object.keys(_d).includes(res.name)) {
            _d[res.name].push({
              name: item[1].replace('*', '')
            });
          } else {
            _d[res.name] = [{
              name: item[1].replace('*', '')
            }];
          }
        }
      });
      let a1 = valueData.slice(0, 1).map(item => Object.entries(item));
      let a2 = valueData.slice(1, valueData.length).map(item => Object.entries(item));
      let _valueData = a2.map(item => {
        // 补全空值字段
        // item = Object.entries(
        //   Object.assign(Object.fromEntries(a1[0].map(aa => [aa[0], ''])), Object.fromEntries(item))
        // );
        if (!item[0][1]) {
          // 产品名称补全
          item[0][1] = a2[0][0][2];
        }
        item = item.map((item1, index) => {
          if (item1[0] == a1[0][index][0]) {
            item1.unshift(a1[0][index][1]);
          }
          return item1;
        });
        return item;
      });
      // _valueData[index]:0 模板名称、1 模板分类、2 模板值
      let newData = [];
      _valueData.map((item, i) => {
        let dObj = recursionCopy(_d);
        for (let index = 0; index < item.length; index++) {
          let d1Index = Object.entries(_d).findIndex(i => item[index][1].includes(i[0]));
          if (d1Index > -1) {
            let d2Index = Object.entries(_d)[d1Index][1].findIndex(i => item[index][0].replace('*', '') === i.name);
            if (d2Index > -1) {
              dObj[Object.entries(_d)[d1Index][0]][d2Index].inputValue = item[index][2];
            }
          }
        }
        newData.push(dObj);
      });
      return newData;
    },
    onImport() {
      this.finished = false;
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          if (this.fileList.length) {
            var _this$currentFileInfo;
            this.column = [];
            this.data = [];
            this.allData = [];
            const fileReader = new FileReader();
            if ((_this$currentFileInfo = this.currentFileInfo.fileList) !== null && _this$currentFileInfo !== void 0 && _this$currentFileInfo.length) {
              fileReader.readAsArrayBuffer(this.currentFileInfo.fileList[this.currentFileInfo.fileList.length - 1].originFileObj);
            }
            fileReader.onload = e => {
              var _sheet2, _sheet$A6$v, _sheet3, _sheet$A;
              let binaryData = e.target.result;
              let workbook = xlsx.read(binaryData, {
                type: 'buffer',
                cellDates: true
              }); // , cellDates: true
              let wsname = workbook.SheetNames[0]; //取第一张表
              let _sheet = workbook.Sheets[wsname];
              // if(_sheet['A5']&&_sheet['A5']=='产品名称'&&_sheet['A6']&&_sheet['A6']=='产品名称')
              if ((_sheet2 = _sheet) !== null && _sheet2 !== void 0 && _sheet2['A6'] && (_sheet$A6$v = _sheet['A6'].v) !== null && _sheet$A6$v !== void 0 && _sheet$A6$v.includes('产品名称') && (_sheet3 = _sheet) !== null && _sheet3 !== void 0 && _sheet3['A7'] && (_sheet$A = _sheet['A7']) !== null && _sheet$A !== void 0 && (_sheet$A = _sheet$A.v) !== null && _sheet$A !== void 0 && _sheet$A.includes(this.form.insuranceName)) {
                let _mergeMap = this.initMerge(_sheet);
                this.processingSheetData(_sheet, _mergeMap, 0);
              } else {
                var _sheet4, _sheet$A2, _sheet5, _sheet$A3;
                wsname = workbook.SheetNames[1]; //取第二张表
                _sheet = workbook.Sheets[wsname];
                if ((_sheet4 = _sheet) !== null && _sheet4 !== void 0 && _sheet4['A3'] && (_sheet$A2 = _sheet['A3']) !== null && _sheet$A2 !== void 0 && _sheet$A2.v.includes('产品名称') && (_sheet5 = _sheet) !== null && _sheet5 !== void 0 && _sheet5['A4'] && (_sheet$A3 = _sheet['A4']) !== null && _sheet$A3 !== void 0 && (_sheet$A3 = _sheet$A3.v) !== null && _sheet$A3 !== void 0 && _sheet$A3.includes(this.form.insuranceName)) {
                  let _mergeMap = this.initMerge(_sheet);
                  this.processingSheetData(_sheet, _mergeMap, 1);
                } else {
                  this.finished = true;
                  this.$message.destroy();
                  return this.$message.error(this.$t('文件列名不可修改或删除，请重新下载模板上传'));
                }
              }
            };
          } else {
            this.finished = true;
            this.$message.destroy();
            this.$message.error(this.$t('请上传文件'));
          }
        } else {
          this.finished = true;
        }
      });
    },
    // 模板格式赋值
    async processingData(data) {
      var _this$insuranceList, _this$planList$, _this$insuranceList2;
      const {
        customerId,
        structureId
      } = this.accountInfo;
      let params = {
        customerId,
        structureId,
        insuranceId: (_this$insuranceList = this.insuranceList) === null || _this$insuranceList === void 0 || (_this$insuranceList = _this$insuranceList.find(i => i.insuranceCustomerId == this.form.insuranceId)) === null || _this$insuranceList === void 0 ? void 0 : _this$insuranceList.id,
        insurancePlanId: ((_this$planList$ = this.planList[0]) === null || _this$planList$ === void 0 ? void 0 : _this$planList$.id) || '',
        applicationId: this.form.applicationId
      };
      const planData = await planRelateData(params);
      for (let index = 0; index < data.length; index++) {
        var _this$planList$find, _templateRenderList;
        const item = data[index];
        let planInfo = item['产品信息'].find(i => i.name == '方案名称');
        let planId = (_this$planList$find = this.planList.find(i => i.name == planInfo.inputValue)) === null || _this$planList$find === void 0 ? void 0 : _this$planList$find.id;
        if (planId) {
          var _item$产品信息$find, _item$产品信息$find2, _this$planList$find2, _item$产品信息$find3, _this$planList$find3;
          // 对应地区校验
          let areaInfo1 = (_item$产品信息$find = item['产品信息'].find(i => i.name == '省')) === null || _item$产品信息$find === void 0 ? void 0 : _item$产品信息$find.inputValue;
          let areaInfo2 = (_item$产品信息$find2 = item['产品信息'].find(i => i.name == '市')) === null || _item$产品信息$find2 === void 0 ? void 0 : _item$产品信息$find2.inputValue;
          let areaInfo = this.planList.find(i => i.name == planInfo.inputValue);
          let isAreaPrice = (_this$planList$find2 = this.planList.find(i => i.name == planInfo.inputValue)) === null || _this$planList$find2 === void 0 ? void 0 : _this$planList$find2.priceType;
          let allShowArea = areaInfo.allShowArea ? JSON.parse(areaInfo.allShowArea) : [];
          if (isAreaPrice == 'AREA_PRICE') {
            if (!areaInfo1 || !areaInfo2) {
              var _this$data;
              (_this$data = this.data) === null || _this$data === void 0 || (_this$data = _this$data[index]) === null || _this$data === void 0 || _this$data.errorMessage.push('地区存在空值');
            } else {
              let find1 = allShowArea.findIndex(i => i.name == areaInfo1);
              if (find1 > -1) {
                let find2 = allShowArea[find1].city.findIndex(i => i.name == areaInfo2);
                if (find2 == -1) {
                  var _this$data2;
                  (_this$data2 = this.data) === null || _this$data2 === void 0 || (_this$data2 = _this$data2[index]) === null || _this$data2 === void 0 || _this$data2.errorMessage.push('地区值与方案区域不符');
                }
              } else {
                var _this$data3;
                (_this$data3 = this.data) === null || _this$data3 === void 0 || (_this$data3 = _this$data3[index]) === null || _this$data3 === void 0 || _this$data3.errorMessage.push('地区值与方案区域不符');
              }
            }
          }
          // 对应附加险校验
          let attachInfo = (_item$产品信息$find3 = item['产品信息'].find(i => i.name == '附加险')) === null || _item$产品信息$find3 === void 0 ? void 0 : _item$产品信息$find3.inputValue;
          let isFormat = true;
          if (attachInfo) {
            var _attachInfo$split;
            attachInfo = (_attachInfo$split = attachInfo.split(',')) === null || _attachInfo$split === void 0 ? void 0 : _attachInfo$split.filter(i => i);
            attachInfo = attachInfo.map(item => {
              var _item$split, _item2;
              item = (_item$split = item.split('-')) === null || _item$split === void 0 ? void 0 : _item$split.filter(i => i);
              if (((_item2 = item) === null || _item2 === void 0 ? void 0 : _item2.length) != 2) {
                isFormat = false;
              }
              return item;
            });
          }
          let attachData = (_this$planList$find3 = this.planList.find(i => i.name == planInfo.inputValue)) === null || _this$planList$find3 === void 0 ? void 0 : _this$planList$find3.attachInfo;
          if (attachData) {
            if (isFormat) {
              var _attachData, _attachData2, _attachInfo;
              attachData = JSON.parse(attachData);
              let buyLimit = (_attachData = attachData) === null || _attachData === void 0 ? void 0 : _attachData.filter(i => i.buyLimit === 1);
              let unBuyLimit = (_attachData2 = attachData) === null || _attachData2 === void 0 ? void 0 : _attachData2.filter(i => i.buyLimit !== 1);
              if (buyLimit.length) {
                if (!attachInfo || attachInfo.length != buyLimit.length) {
                  var _this$data4;
                  (_this$data4 = this.data) === null || _this$data4 === void 0 || (_this$data4 = _this$data4[index]) === null || _this$data4 === void 0 || _this$data4.errorMessage.push('请补全必购附加险');
                } else {
                  buyLimit.map(item => {
                    let _info = attachInfo.find(i => i[0] == item.name);
                    if (_info) {
                      let _plan = item.attachPlan.findIndex(i => i.name == _info[1]);
                      if (_plan == -1) {
                        var _this$data5;
                        if (((_this$data5 = this.data) === null || _this$data5 === void 0 || (_this$data5 = _this$data5[index]) === null || _this$data5 === void 0 ? void 0 : _this$data5.errorMessage.findIndex(i => i == '找不到附加险对应方案')) == -1) {
                          var _this$data6;
                          (_this$data6 = this.data) === null || _this$data6 === void 0 || (_this$data6 = _this$data6[index]) === null || _this$data6 === void 0 || _this$data6.errorMessage.push('找不到附加险对应方案');
                          return;
                        }
                      }
                    } else {
                      var _this$data7;
                      if (((_this$data7 = this.data) === null || _this$data7 === void 0 || (_this$data7 = _this$data7[index]) === null || _this$data7 === void 0 ? void 0 : _this$data7.errorMessage.findIndex(i => i == '找不到附加险')) == -1) {
                        var _this$data8;
                        (_this$data8 = this.data) === null || _this$data8 === void 0 || (_this$data8 = _this$data8[index]) === null || _this$data8 === void 0 || _this$data8.errorMessage.push('找不到附加险');
                        return;
                      }
                    }
                  });
                }
              }
              if (unBuyLimit.length && (_attachInfo = attachInfo) !== null && _attachInfo !== void 0 && _attachInfo.length) {
                unBuyLimit.map(item => {
                  let _info = attachInfo.find(i => i[0] == item.name);
                  if (_info) {
                    let _plan = item.attachPlan.findIndex(i => i.name == _info[1]);
                    if (_plan == -1) {
                      var _this$data9;
                      if (((_this$data9 = this.data) === null || _this$data9 === void 0 || (_this$data9 = _this$data9[index]) === null || _this$data9 === void 0 ? void 0 : _this$data9.errorMessage.findIndex(i => i == '找不到附加险对应方案')) == -1) {
                        var _this$data0;
                        (_this$data0 = this.data) === null || _this$data0 === void 0 || (_this$data0 = _this$data0[index]) === null || _this$data0 === void 0 || _this$data0.errorMessage.push('找不到附加险对应方案');
                        return;
                      }
                    }
                  } else {
                    buyLimit.map(item => {
                      let _info = attachInfo.find(i => i[0] == item.name);
                      if (!_info) {
                        var _this$data1;
                        if (((_this$data1 = this.data) === null || _this$data1 === void 0 || (_this$data1 = _this$data1[index]) === null || _this$data1 === void 0 ? void 0 : _this$data1.errorMessage.findIndex(i => i == '找不到附加险')) == -1) {
                          var _this$data10;
                          (_this$data10 = this.data) === null || _this$data10 === void 0 || (_this$data10 = _this$data10[index]) === null || _this$data10 === void 0 || _this$data10.errorMessage.push('找不到附加险');
                          return;
                        }
                      }
                    });
                  }
                });
              }
            } else {
              var _this$data11;
              (_this$data11 = this.data) === null || _this$data11 === void 0 || (_this$data11 = _this$data11[index]) === null || _this$data11 === void 0 || _this$data11.errorMessage.push('附加险填写格式错误');
            }
          }
        } else {
          var _this$data12, _this$planList$2;
          (_this$data12 = this.data) === null || _this$data12 === void 0 || (_this$data12 = _this$data12[index]) === null || _this$data12 === void 0 || _this$data12.errorMessage.push('找不到方案名称');
          planId = ((_this$planList$2 = this.planList[0]) === null || _this$planList$2 === void 0 ? void 0 : _this$planList$2.id) || '';
        }
        this.discountInfoList.push(planData.discountInfo);
        // data[index].discountInfo = res.discountInfo;
        let templateRenderList = planData.templateRenderList;
        console.log(templateRenderList, 'templateRenderList');
        let replaceObj = {
          被保人姓名: '员工姓名',
          被保人证件号: '员工证件号',
          被保人性别: '员工性别',
          被保人年龄: '员工年龄'
        };
        (_templateRenderList = templateRenderList) === null || _templateRenderList === void 0 || _templateRenderList.forEach(item => {
          if (item.code === 'insured') {
            item.item.forEach(insuredItem => {
              if (replaceObj[insuredItem.name]) {
                insuredItem.name = replaceObj[insuredItem.name];
              }
            });
          }
        });
        templateRenderList = this.fromTemplateAssign(recursionCopy(templateRenderList));
        // 赋值
        templateRenderList.forEach(temp => {
          let info = Object.entries(item).find(i => i[0].includes(temp.name));
          if (info) {
            temp.item.forEach(t1 => {
              var _t1$value$find, _t1$value$find2;
              // console.log(info[1], t1, 'info[1]');
              let isInfo = info[1].find(i => {
                let trueNme = temp.code === 'insured' && replaceObj[i.name] ? replaceObj[i.name] : i.name;
                return trueNme == t1.name;
              });
              // let isInfo = info[1].find(i => i.name == t1.name);
              if (isInfo) {
                switch (t1.display) {
                  case 'text':
                    t1.inputKey = isInfo.inputValue;
                    break;
                  case 'time':
                    t1.inputKey = isInfo.inputValue; //  moment(isInfo.inputValue).format('YYYY-MM-DD');
                    break;
                  case 'radio':
                    t1.inputKey = (_t1$value$find = t1.value.find(i => i.value == isInfo.inputValue)) === null || _t1$value$find === void 0 ? void 0 : _t1$value$find.key;
                    break;
                  case 'dropDownBox':
                    t1.inputKey = (_t1$value$find2 = t1.value.find(i => i.value == isInfo.inputValue)) === null || _t1$value$find2 === void 0 ? void 0 : _t1$value$find2.key;
                    break;
                  default:
                    break;
                }
                // dropDownBox(region) 渲染逻辑
                // else{
                //   let area1=info[1].find(i => i.name =='省')
                //   let area2=info[1].find(i => i.name =='市')
                //   if(area1&&area2&&t1.display=='dropDownBox(region)'){
                //   }
                // }
              }
            });
            data[index][info[0]] = temp.item;
          }
        });
      }
      this.collectionIdCard(data);
      this.validateError(data);
      data = recursionCopy(data).map(item1 => {
        let _item = [];
        Object.entries(item1).map(ii => {
          let _find = this.infoKeys.find(i => i.name == ii[0]);
          if (_find) {
            _item.push({
              code: _find.code,
              name: _find.name,
              item: ii[1]
            });
          }
        });
        return _item;
      });
      data = {
        insuranceId: (_this$insuranceList2 = this.insuranceList) === null || _this$insuranceList2 === void 0 || (_this$insuranceList2 = _this$insuranceList2.find(i => i.insuranceCustomerId == this.form.insuranceId)) === null || _this$insuranceList2 === void 0 ? void 0 : _this$insuranceList2.id,
        applicationId: this.form.applicationId,
        customerInsuranceId: this.form.insuranceId,
        insuredInfo: this.dataProcessing(data)
      };
      return data;
    },
    // 统一处理为传参格式
    dataProcessing(data) {
      console.log(data, 'dataProcessing');
      data = data.map((item1, index) => {
        let obj = {
          commonInfo: {}
        };
        item1.map(item2 => {
          item2.item = item2.item.map(item3 => {
            if (item2.name != '产品信息') {
              let obj = {
                code: item3.code,
                name: item3.name,
                display: item3.display,
                valData: item3.inputKey
              };
              if (item3.value) {
                var _item3$value$find;
                obj.valData1 = ((_item3$value$find = item3.value.find(i => i.key == item3.inputKey)) === null || _item3$value$find === void 0 ? void 0 : _item3$value$find.value) || '';
              }
              // 批量导入暂时不处理多级地区识别逻辑
              // if (item3.display == 'dropDownBox(region)') {
              //   obj.defaultValue = item3.inputKey;
              //   obj.valData = item3.inputValue;
              // }
              return obj;
            }
            return item3;
          });
          if (item2.name == '产品信息') {
            Object.assign(obj.commonInfo, this.commonInfoCode(item2.item, index));
          } else if (item2.name == '保险信息') {
            obj.commonInfo.commonTemplate = item2.item;
          } else {
            Object.assign(obj, {
              [item2.code]: item2.item
            });
          }
        });
        return obj;
      });
      return data;
    },
    collectionIdCard(data) {
      this.insuredReapatIdCard = {};
      data.forEach(item1 => {
        let insuredInfo = item1['被保险人信息'];
        insuredInfo.forEach(item2 => {
          if (item2.code === 'insuredIdNo') {
            if (this.insuredReapatIdCard[item2.inputKey] > 0) {
              this.insuredReapatIdCard[item2.inputKey] = this.insuredReapatIdCard[item2.inputKey] + 1;
            } else {
              this.insuredReapatIdCard[item2.inputKey] = 1;
            }
          }
        });
      });
    },
    // 获取文字对应code参数
    commonInfoCode(data, index) {
      let obj = {};
      obj.insureCount = 1;
      let insurance = data.find(i => i.name == '产品名称');
      let insuranceInfo = this.insuranceList.find(i => i.customerInsuranceName == insurance.inputValue);
      obj.insuranceCustomerCode = insuranceInfo === null || insuranceInfo === void 0 ? void 0 : insuranceInfo.insuranceCustomerCode;
      obj.insuranceName = insuranceInfo.customerInsuranceName;
      let plan = data.find(i => i.name == '方案名称');
      let planInfo = this.planList.find(i => i.name == plan.inputValue);
      if (planInfo) {
        obj.insurancePlanCode = planInfo.mark;
        obj.insurancePlanName = planInfo.name;
        obj.insurancePlanAmount = planInfo.amount;
        obj.price = planInfo.price;
        // 区域保费地区赋值
        if (planInfo.priceType === 'AREA_PRICE') {
          let allShowArea = planInfo.allShowArea ? JSON.parse(planInfo.allShowArea) : [];
          if (allShowArea.length) {
            let area1 = data.find(i => i.name == '省');
            let area2 = data.find(i => i.name == '市');
            if (area1 !== null && area1 !== void 0 && area1.inputValue && area2.inputValue) {
              allShowArea.forEach(item => {
                if (area1.inputValue == item.name) {
                  let _find = item.city.find(i => i.name == area2.inputValue);
                  if (_find) {
                    obj.areaCode = _find.code || '';
                    obj.areaName = item.name + ' ' + _find.name;
                    obj.areaPrice = _find.price || '';
                    if (this.discountInfoList[index].length) {
                      var _this$discountInfoLis, _this$discountInfoLis2, _this$discountInfoLis3;
                      obj.discountMode = ((_this$discountInfoLis = this.discountInfoList[index].find(i => i.areaIndex == _find.areaIndex)) === null || _this$discountInfoLis === void 0 ? void 0 : _this$discountInfoLis.discountMode) || '';
                      obj.discountRatio = ((_this$discountInfoLis2 = this.discountInfoList[index].find(i => i.areaIndex == _find.areaIndex)) === null || _this$discountInfoLis2 === void 0 ? void 0 : _this$discountInfoLis2.discountRatio) || '';
                      obj.discountAmount = ((_this$discountInfoLis3 = this.discountInfoList[index].find(i => i.areaIndex == _find.areaIndex)) === null || _this$discountInfoLis3 === void 0 ? void 0 : _this$discountInfoLis3.discountAmount) || '';
                    }
                  }
                }
              });
            }
          }
        } else {
          var _this$discountInfoLis4;
          obj.areaCode = '';
          obj.areaPrice = '';
          obj.areaName = '';
          if ((_this$discountInfoLis4 = this.discountInfoList[index]) !== null && _this$discountInfoLis4 !== void 0 && _this$discountInfoLis4.length) {
            obj.discountMode = this.discountInfoList[index][0].discountMode;
            obj.discountRatio = this.discountInfoList[index][0].discountRatio;
            obj.discountAmount = this.discountInfoList[index][0].discountAmount;
          }
        }
        //附加险信息
        let attachOptions = planInfo.attachInfo && JSON.parse(planInfo.attachInfo);
        if (attachOptions.length) {
          var _data$find;
          let attachValue = [];
          if (attachOptions && attachOptions.length) {
            attachOptions.forEach(item => {
              if (item.buyLimit === 1) {
                item.disabled = true;
                item.allowClear = false;
                attachValue.push(item.attachId);
              }
            });
          }
          // 附加险赋值
          let attach = (_data$find = data.find(i => i.name == '附加险')) === null || _data$find === void 0 ? void 0 : _data$find.inputValue;
          let isFormat = true;
          if (attach) {
            var _attach$split;
            attach = (_attach$split = attach.split(',')) === null || _attach$split === void 0 ? void 0 : _attach$split.filter(i => i);
            if (attach.length) {
              attach = attach.map(item => {
                var _item$split2, _item3;
                item = (_item$split2 = item.split('-')) === null || _item$split2 === void 0 ? void 0 : _item$split2.filter(i => i);
                if (((_item3 = item) === null || _item3 === void 0 ? void 0 : _item3.length) != 2) {
                  isFormat = false;
                }
                return item;
              });
            }
          }
          let tableData = this.changeAdditional(attachValue, attachOptions);
          if (isFormat) {
            attachOptions.map((item, index) => {
              if (item.buyLimit === 1) {
                var _attach;
                if ((_attach = attach) !== null && _attach !== void 0 && _attach.length) {
                  let _i = attach.findIndex(i => i[0] == item.name);
                  if (_i > -1) {
                    item.attachPlan.map(plan => {
                      if (attach[_i][1] == plan.name) {
                        tableData = this.amountSelect(plan.id, tableData.findIndex(i => i.name == item.name), tableData);
                      }
                    });
                  }
                }
              } else {
                var _attach2;
                if ((_attach2 = attach) !== null && _attach2 !== void 0 && _attach2.length) {
                  let _i = attach.findIndex(i => i[0] == item.name);
                  if (_i > -1) {
                    item.attachPlan.map(plan => {
                      if (attach[_i][1] == plan.name) {
                        attachValue.push(item.attachId);
                        tableData = this.changeAdditional(attachValue, attachOptions);
                        tableData = this.amountSelect(plan.id, tableData.findIndex(i => i.name == item.name), tableData);
                      }
                    });
                  }
                }
              }
            });
            let insuranceAttachPlanCode = tableData.map(i => i.mark).join(',');
            let attachInfo = tableData.map(item => {
              var _item$attachPlan;
              item.attachPlan = (_item$attachPlan = item.attachPlan) === null || _item$attachPlan === void 0 ? void 0 : _item$attachPlan.filter(i => insuranceAttachPlanCode.includes(i.mark));
              return item;
            });
            obj.insuranceAttachPlanCode = insuranceAttachPlanCode;
            obj.attachInfo = attachInfo;
          } else {
            obj.insuranceAttachPlanCode = '';
            obj.attachInfo = [];
          }
        }
      }
      return obj;
    },
    amountSelect(value, recordIndex, tableData) {
      let attachPLan = tableData[recordIndex].attachPlan.find(item => item.id === value);
      if (attachPLan) {
        tableData[recordIndex].price = attachPLan.price;
        tableData[recordIndex].mark = attachPLan.mark;
        tableData[recordIndex].attachPlanId = value;
        tableData = [...tableData];
      }
      return tableData;
    },
    changeAdditional(attachValue, attachOptions) {
      let tableData = [];
      attachValue && attachValue.forEach(value => {
        let selectItem = attachOptions.filter(item => item.attachId === value);
        if (selectItem.length) {
          let item = selectItem[0];
          //默认选中第一个方案
          if (!item.attachPlan) {
            //保障额度一个都没有的情况
            item.attachPlanId = '-';
            item.price = '-';
            item.amount = '-';
          } else {
            var _item$attachPlan2, _item$attachPlan3, _item$attachPlan4;
            item.attachPlanId = item.attachPlanId || ((_item$attachPlan2 = item.attachPlan) === null || _item$attachPlan2 === void 0 || (_item$attachPlan2 = _item$attachPlan2[0]) === null || _item$attachPlan2 === void 0 ? void 0 : _item$attachPlan2.id) || '-';
            item.price = item.price || ((_item$attachPlan3 = item.attachPlan) === null || _item$attachPlan3 === void 0 || (_item$attachPlan3 = _item$attachPlan3[0]) === null || _item$attachPlan3 === void 0 ? void 0 : _item$attachPlan3.price) || '-';
            item.mark = item.mark || ((_item$attachPlan4 = item.attachPlan) === null || _item$attachPlan4 === void 0 || (_item$attachPlan4 = _item$attachPlan4[0]) === null || _item$attachPlan4 === void 0 ? void 0 : _item$attachPlan4.mark) || '-';
            if (item.attachPlan.length === 1) {
              //只有一个方案的直接保障额度使用文本展示
              item.amount = item.amount || item.attachPlan[0].amount;
            }
          }
          tableData.push(item);
        }
      });
      return tableData;
    },
    // 校验errorMessage
    validateError(data) {
      data.map((item, index) => {
        var _item4;
        item = Object.entries(item) || [];
        (_item4 = item) === null || _item4 === void 0 || _item4.map(item1 => {
          if (item1[0] != '产品信息') {
            item1[1].map(item2 => {
              var _item2$name, _item2$name2, _item2$name3, _item2$name4, _item2$name5, _item2$name6;
              if (item1[0] === '被保险人信息') {
                if (item2.name === '员工证件号' && this.insuredReapatIdCard[item2.inputKey] > 1) {
                  this.data[index].errorMessage.push('员工证件号' + item2.inputKey + '重复');
                }
              }
              if (item2.isOptional === 0 && !item2.inputKey) {
                this.data[index].errorMessage.push(item2.name + '不能为空');
              }
              console.log(item2.name, item2.inputKey, 'item2.name, item2.inputKey');
              if (item2.name === '被保公司名称') {
                let companyName = item2.inputKey;
                if (companyName && this.companyBlackList.includes(companyName.trim().toLowerCase())) {
                  this.data[index].errorMessage.push('被保公司名称在黑名单中，不允许投保');
                }
              }
              if ((_item2$name = item2.name) !== null && _item2$name !== void 0 && _item2$name.includes('证件号') && item2.inputKey) {
                let idTypeItem = item1[1].find(i => i.name.includes('证件类型'));
                //证件类型为身份证时，校验身份证格式
                if (!isCardNo(item2.inputKey) && idTypeItem && idTypeItem.inputKey === 'IDCARD') {
                  this.data[index].errorMessage.push(item2.name + '格式错误');
                }
                if (idTypeItem && idTypeItem.inputKey === 'IDCARD' && this.personBlackList.includes(item2.inputKey.trim().toLowerCase())) {
                  this.data[index].errorMessage.push('身份证号码在黑名单中，不允许投保');
                }
              } /*  */
              if ((_item2$name2 = item2.name) !== null && _item2$name2 !== void 0 && _item2$name2.includes('手机号') && item2.inputKey) {
                if (!isPhone(item2.inputKey)) {
                  this.data[index].errorMessage.push(item2.name + '格式错误');
                }
              }
              if ((_item2$name3 = item2.name) !== null && _item2$name3 !== void 0 && _item2$name3.includes('邮箱') && item2.inputKey) {
                if (!checkEmail(item2.inputKey)) {
                  this.data[index].errorMessage.push(item2.name + '格式错误');
                }
              }
              if ((_item2$name4 = item2.name) !== null && _item2$name4 !== void 0 && _item2$name4.includes('投保人生日') && item2.inputKey) {
                var _item1$1$find;
                let idNo = (_item1$1$find = item1[1].find(i => i.name == '投保人证件号')) === null || _item1$1$find === void 0 ? void 0 : _item1$1$find.inputKey;
                if (idNo && isCardNo(idNo)) {
                  idNo = idNo + '';
                  let birth = idNo.substr(6, 4) + '-' + idNo.substr(10, 2) + '-' + idNo.substr(12, 2) || '';
                  if (item2.inputKey != birth) {
                    this.data[index].errorMessage.push(item2.name + '与证件号不一致');
                  }
                }
              }
              if ((_item2$name5 = item2.name) !== null && _item2$name5 !== void 0 && _item2$name5.includes('被保人生日') && item2.inputKey) {
                var _item1$1$find2;
                let idNo = (_item1$1$find2 = item1[1].find(i => i.name == '被保人证件号')) === null || _item1$1$find2 === void 0 ? void 0 : _item1$1$find2.inputKey;
                if (idNo && isCardNo(idNo)) {
                  idNo = idNo + '';
                  let birth = idNo.substr(6, 4) + '-' + idNo.substr(10, 2) + '-' + idNo.substr(12, 2) || '';
                  if (item2.inputKey != birth) {
                    this.data[index].errorMessage.push(item2.name + '与证件号不一致');
                  }
                }
              }
              if ((_item2$name6 = item2.name) !== null && _item2$name6 !== void 0 && _item2$name6.includes('与投保人关系') && item2.inputKey == '01') {
                var _applicantInfo$;
                let res = true;
                let applicantInfo = item.find(i => i[0].includes('投保人信息'));
                if (applicantInfo && (_applicantInfo$ = applicantInfo[1]) !== null && _applicantInfo$ !== void 0 && _applicantInfo$.length) {
                  applicantInfo[1].forEach((app, appIndex) => {
                    let name = '';
                    if (app.name.indexOf('姓名') > -1) {
                      name = '姓名';
                    } else if (app.name.indexOf('手机号') > -1) {
                      name = '手机号';
                    } else if (app.name.indexOf('证件类型') > -1) {
                      name = '证件类型';
                    } else if (app.name.indexOf('性别') > -1) {
                      name = '性别';
                    } else if (app.name.indexOf('生日') > -1) {
                      name = '生日';
                    } else if (app.name.indexOf('邮箱') > -1) {
                      name = '邮箱';
                    } else if (app.name.indexOf('证件号') > -1) {
                      name = '证件号';
                    }
                    if (name) {
                      let has = item1[1].find(i => {
                        var _i$name;
                        return (_i$name = i.name) === null || _i$name === void 0 ? void 0 : _i$name.includes(name);
                      });
                      if (has && has.inputKey != app.inputKey) {
                        res = false;
                      }
                    }
                  });
                }
                if (!res) {
                  this.data[index].errorMessage.push('与投保人关系为本人的信息与投保人不一致');
                }
              }
            });
          }
        });
      });
    },
    fromTemplateAssign(template) {
      template.forEach((item, index) => {
        if (item.code === 'applicant') {
          if (this.isPERSON) {
            template[index].item[0].inputKey = 'NATURAL_PERSON';
            template[index].item.push(...item.personal);
          } else {
            var _item$company;
            template[index].item[0].inputKey = 'COMPANY';
            if (item !== null && item !== void 0 && (_item$company = item.company) !== null && _item$company !== void 0 && _item$company.length) {
              template[index].item.push(...item.company);
            }
          }
          if (item.item[0].code === 'applicantType') {
            template[index].item[0].display = 'radio';
          }
        }
        item.item.forEach((item1, index1) => {
          if (item1.display == 'dropDownBox(region)') {
            template[index].item[index1].inputKey = [];
          }
          if (item1.display == 'dropDownBox' && !item1.inputKey) {
            template[index].item[index1].inputKey = undefined;
          }
          if (item1.name == '验证码') {
            template[index].item.splice(index1, 1);
          }
        });
      });
      return template;
    },
    async changeInsuranceId() {
      if (this.form.insuranceId) {
        var _this$insuranceList$f;
        this.form.insuranceName = this.insuranceList.find(i => i.insuranceCustomerId == this.form.insuranceId).customerInsuranceName;
        this.form.applicationId = this.insuranceList.find(i => i.insuranceCustomerId === this.form.insuranceId).applicationId;
        this.form.insuranceCustomerId = this.form.insuranceId;
        const res = await mainPlanResource({
          insuranceId: (_this$insuranceList$f = this.insuranceList.find(i => i.insuranceCustomerId == this.form.insuranceId)) === null || _this$insuranceList$f === void 0 ? void 0 : _this$insuranceList$f.id
        });
        this.planList = res.items.map(item => {
          item.rightsCont = JSON.parse(item.rights);
          return item;
        });
      }
    },
    closeModal() {
      if (this.finished) {
        this.fileList = [];
        this.form.insuranceId = undefined;
        this.form.insuranceName = undefined;
        this.$refs.formRef.resetFields();
        this.$emit('cancel');
      }
    }
  }
};